module.exports = __webpack_public_path__ + "img/广告图一.71debc97.jpg";